<template>
  <div class="wrapper">
    <div class="section">
      <!-- ******* SLIDER ********** -->
      <div class="slider" style="max-height:480px">
        <div class="pricing-4">
          <div class="container">
            <div class="row">
              <div class="section-space"></div>
              <div class="col-sm-12 col-md-12 ml-auto mr-auto" v-show="!isMobile()">
                <el-carousel height="400px" class="carousel-centered">
                    <a v-for="item in planes"
                    :key="item.titulo" 
                    :href="item.link"
                    :target="item.target"
                    :class="!item.link && 'inactiveLink'"
                    >
                  <el-carousel-item  class="carousel_item_background" :key="item.titulo"
                    :style="{ 'background-image': 'url(' + item.urlImage + ')' }"
                  >
                   
                    <!-- v-bind:style="{ backgroundImage: 'url(' + item.urlImage + ')' }" -->
                    <card type="testimonial" plain>
                      <!-- <h2 class="title text-white">{{ item.titulo }}</h2>
                      <div class="icon icon-info">
                        <i class="now-ui-icons business_briefcase-24"></i>
                      </div> -->
                      <div class="section-space"></div>
                      <div class="row">
                        <div class="col-sm-12">
                          <!-- <h5 class="card-description planes">{{item.descripcion}}</h5> -->
                        </div>
                      </div>
                    </card>
              
                  </el-carousel-item>
                  </a>
           
                </el-carousel>
              </div>
              <div class="col-sm-12 col-md-12 ml-auto mr-auto" v-show="isMobile()">
                <el-carousel height="400px" class="carousel-centered">
                  <a v-for="item in planes"
                    :key="item.titulo" 
                    :href="item.link"
                    :target="item.target"
                    :class="!item.link && 'inactiveLink'"
                    >
                  <el-carousel-item class="carousel_item_background"
                    :style="{ 'background-image': 'url(' + item.urlImageMobile + ')' }"
                  >
                    <!-- v-bind:style="{ backgroundImage: 'url(' + item.urlImage + ')' }" -->
                    <card type="testimonial" plain>
                      <!-- <h2 class="title text-white">{{ item.titulo }}</h2>
                      <div class="icon icon-info">
                        <i class="now-ui-icons business_briefcase-24"></i>
                      </div> -->
                      <div class="section-space"></div>
                      <div class="row">
                        <div class="col-sm-12">
                          <!-- <h5 class="card-description planes">{{item.descripcion}}</h5> -->
                        </div>
                      </div>
                    </card>
                  </el-carousel-item>
                </a>
                </el-carousel>
              </div>
            <!--  <div class="col-sm-12 col-md-3 text-center" style="background-color: #0268B2">
                <div class="section-space"></div>
                <div class="section-space"></div> -->
                <!-- <p class="sssalud">OSAPM RNOS: 1-1820-0 RNEMP: 1417 SSSALUD 0800-222-72583  <a href="www.sssalud.gov.ar" class="text-white">www.sssalud.gov.ar</a> Avellaneda 2144 (C1406FYT) Ciudad Autónoma de Buenos Aires (54-11) 4633-7878</p> -->
                <!-- <div class="sssalud-linea">
                  <p>OSAPM RNOS: 1-1820-0</p>
                  <p>RNEMP: 1417</p>
                  <p>SSSALUD 0800 222 72583</p>
                  <p>www.sssalud.gov.ar</p>
                  <p>Avellaneda 2144 (C1406FYT)</p>
                  <p>Ciudad Autónoma de</p>
                  <p>Buenos Aires</p>
                  <p>Tel: (54-11) 4633-7878</p>
                </div>-->
                <!-- <p class="sssalud-linea">{{$store.getters["resource/getByName"]("Text1").value}}</p> -->

               <!-- <div class="sssalud-linea" v-html="htmlInfoObraSocial"></div>-->

             <!--    <div class="section-space"></div>
                <button
                  type="button"
                  role="link"
                  class="button btn-afiliarme"
                  onclick="window.location.href='#/afiliarme'"
                >Quiero Afiliarme</button>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <!-- ******* END-SLIDER ********** -->
      <!--     *********     ACCESOS   *********      -->
      <div class="section">
        <div class="section-space"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <card>
                 <!--    <img slot="image" src="images/cartillaPrestadores.jpg" class="rounded" alt />-->
                <div class="info info-hover text-center">
                  <a href="#/cartillaPrestadores">
                    <div class="icon icon-primary icon-circle">
                      <i class="now-ui-icons design_bullet-list-67"></i>
                    </div>
                    <h4 class="info-title">Cartilla Prestadores</h4>
                  </a>
                  <p class="description">Ingrese al sistema de consultas Prestadores.</p>
                </div>
              </card>
            </div>
            <div class="col-md-4">
              <card>
              <!--   <img slot="image" src="images/accesoAfiliado.jpg" class="rounded" alt />-->
                <div class="info info-hover text-center">
                  <a href="#/login" target="_blank">
                    <div class="icon icon-success icon-circle">
                      <i class="now-ui-icons users_single-02"></i>
                    </div>
                    <h4 class="info-title">Acceso Afiliados</h4>
                  </a>
                  <p class="description">Ingrese al sistema de consultas privadas del Afiliado.</p>
                </div>
              </card>
            </div>
            <div class="col-md-4">
              <card>
               <!--   <img slot="image" src="images/accesoPrestador.jpg" class="rounded" alt />-->
                <div class="info info-hover text-center">
                  <a href="#/prestador/login" target="_blank">
                    <div class="icon icon-info icon-circle">
                      <i class="now-ui-icons users_circle-08"></i>
                    </div>
                    <h4 class="info-title">Acceso Prestadores</h4>
                  </a>
                  <p class="description">Ingrese al sistema de consultas privadas del Afiliado.</p>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <!--     *********    END FEATURES 8      *********      -->
      <!--     *********    END ACCESOS     *********      -->
      <div class="separator-line separator-primary"></div>

      <!--     *********    END NOTICIAS     *********      -->
      <ultimas-noticias-home></ultimas-noticias-home>
      <!--     *********    END NOTICIAS     *********      -->
      <div class="separator-line separator-primary"></div>
    </div>
  </div>
</template>
<script>
import {
  Card,
  Button,
  Badge,
  InfoSection,
  FormGroupInput,
  Checkbox
} from '@/components';
import { Carousel, CarouselItem, Select, Option } from 'element-ui';
import UltimasNoticiasHome from './cmsComponents/UltimasNoticiasHome';
import { mapState, mapActions } from 'vuex';
import { setTimeout } from 'timers';
import { debug } from 'util';

export default {
  name: 'home',
  bodyClass: 'home',
  components: {
    Card,
    InfoSection,
    Badge,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [UltimasNoticiasHome.name]: UltimasNoticiasHome
  },
  methods: {
    getUrlFromBackend: function(relativePath) {
      return process.env.VUE_APP_BACKEND + relativePath;
    }
  },
  async created() {
    await this.$store.dispatch('resource/getAll');
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        speciality: ''
      },
      model: {},
      planes: []
    };
  },
  computed: {
    htmlInfoObraSocial() {
      var value = this.$store.getters['resource/getByName'](
        'HtmlInfoObraSocial'
      );
      if (value) return value.value;
      return '';
    }
  },
  mounted() {
    this.$zaiq()
      .get('CarouselItem/AdvancedGetAll')
      .then(response => {
        console.log(response.data.result.items);
       
        this.planes =  response.data.result.items;


      });

    this.$zaiq()
      .get('Foo/GetBar')
      .then(
        response =>
          (this.model = {
            sssalud:
              'OSAPM RNOS: 1-1820-0 RNEMP: 1417 SSSALUD 0800 222 72583 www.sssalud.gov.ar Avellaneda 2144 (C1406FYT) Ciudad Autónoma de Buenos Aires (54-11) 4633-7878'
          })
      );
  }
};
</script>
<style scoped>
.btn-afiliarme {
  background-color: #ffffff;
  color: #0268b2;
  text-align: center;
  border: none;
  font-size: 25px;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  height: 100px;
  width: 100%;
}

.btn-afiliarme:hover {
  text-decoration:none;
  background-color: #ffffff;
  color:#0268b2;
  text-shadow: #0268b2 0.1em 0.1em 0.2em;
  cursor:pointer;
}

.carousel_item_background{
  background-size: cover !important;
} 
.carousel-centered {
  /* max-width: 650px; */
  margin-left: auto;
  margin-right: auto;
}
.section {
  padding: 0px 0;
  position: relative;
  background: #ffffff;
}
.about-us .about-description {
  padding: 0px 0px 0px 0px;
}

.sssalud {
  /* color: #307AC9; */
  color: #ffffff;
  font-size: 16px;
  padding-top: 10px;
  font-weight: 600;
  text-align: justify;
}
div.sssalud-linea >>> p {
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  padding-top: 10px;
  font-weight: 600;
  text-align: justify;
  margin: 0%;
  padding: 0%;
}

.planes {
  color: #0368b2;
  font-size: 18px;
  padding-top: 10px;
  font-weight: 600;
}

.inactiveLink {
   pointer-events: none;
   cursor: default;
}
</style>
